export const isLocal = __ENV_LOCAL__ // localhost에서만 동작하도록 설정.

export const isDevelop = __ENV_DEVELOPMENT__ || __ENV_LOCAL__

export const isStaging = __ENV_STAGING__

export const isProduction = __ENV_PRODUCTION__

export const isQc = __ENV_QC__

// 로그인 popup 사용 여부.
export const useLoginPopup: boolean = false

// 예약 발송 메일 사용 여부.
export const useScheduledEmail: boolean = true

// Local Thread Viewer 사용 여부 - email-thread-viewer 디버깅 시에 사용. default: false.
export const useLocalThreadViewer: boolean = false // isLocal

// Inner Viewer (host React 트리에 직접 마운트하는 viewer 모드) 사용 여부.
// OMD-237: desktop 기본을 IFrameViewer 로 전환 (대용량 메일 host DOM 노드 폭증 완화) 하면서
// InnerViewer 코드는 롤백 경로로 유지. 본 값 false → desktop IFrameViewer 기본.
// mobile WebView (OfficeMail user-agent) 는 본 값과 무관하게 IFrameViewer 강제.
// 롤백이 필요하면 localStorage `__forceInnerViewer = 'true'` 로 desktop InnerViewer 강제
// (barrel 분기 참조 — rebuild / redeploy 없이 사용자 단위).
export const useInnerViewer: boolean = false

// 이 시간보다 이전에 받은 메일을 요청할 때는 무조건 한개씩 요청한다.
export const JmapSingleRequestLimit: number = 13 * 24 * 60 * 60 * 1000 // 14일 -1일.

// Jmap Quota 사용 여부.(false 일 경우 mailbox api 사용)
export const useJmapQuota: boolean = true

// Email Detail DB 사용 여부.
export const useEmailDetailDB: boolean = true

// 목록만 보기(화면 분할 안함) 사용 여부.
export const useEmailListOnly: boolean = true

// Todo 사용 여부.
export const useTodo: boolean = true

// Quick-Agent 사용 여부.
export const useQuickAgent: boolean = true

// email filter 사용 여부.
export const useEmailFilter: boolean = true

// 대용량 첨부파일 사용 여부.
export const useLargeAttachment: boolean = true

// sendMailMode : popup, window, tab
export const defaultSendMailMode = 'tab'

// 인쇄 기능 사용 여부.
export const usePrint: boolean = true // (isLocal === true)

// 수신확인(Read Receipt) 기능 사용 여부.
export const useReadReceipt: boolean = true

// 사용할 에디터 종류 (PR-N7). 'tinymce' = 기존 TinyMCE 어댑터 (iframe 마운트) / 'ngw' =
// @ngweditor/react 어댑터 (inline 마운트). 두 어댑터 모두 IEditor + IMailEditor 인터페이스를
// 동일하게 구현 (PR-7c / PR-N4) 하므로 호출부는 어댑터 종류와 무관. 'ngw' 활성화 시점
// 2026-05-12 — PR-N1 ~ PR-N7 의 어댑터 표면 100% 완성 후 운영 검증 단계 진입. 운영 검증
// (회귀 0건 + 사용자 판단 시점) 통과 시 PR-N8 에서 본 플래그 자체 제거 + TinyMCE 어댑터 /
// public/editor/ 자산 일괄 삭제. 회귀 발견 시 root-cause fix 우선 — 'tinymce' 롤백은 fix 가
// 24시간+ 추정 시만.
export const editorType: 'tinymce' | 'ngw' = 'ngw'

// 이메일 검색 백엔드 선택: 'JMAP' | 'OPEN_SEARCH' (OFM-212)
export type EmailSearchProvider = 'JMAP' | 'OPEN_SEARCH'
export const emailSearchProvider: EmailSearchProvider = 'OPEN_SEARCH'

// 검색 결과 표시 단위: 'EMAIL'(개별 메일) | 'THREAD'(스레드 묶음). 기본 'EMAIL' (현행 유지). (OMD-21)
// 'THREAD' 전환 시 OpenSearch가 준 emailIds → Email/get(['threadId']) → Thread/get →
// Email/get(스레드 전체) 경로로 스레드를 재구성한다. 페이지네이션/total/hasMoreData 는
// emailId 기준을 유지하고(Option A), threadId dedupe 는 표시 계층에서 수행한다.
export type SearchResultDisplayType = 'EMAIL' | 'THREAD'
export const searchResultDisplayType: SearchResultDisplayType = 'EMAIL'

const varsParams = {
  isLocal,
  isStaging,
  isProduction,
  useLoginPopup,
  useScheduledEmail,
  useLocalThreadViewer,
  useJmapQuota,
  useTodo,
  usePrint,
  useQuickAgent,
  useReadReceipt,
  editorType,
  emailSearchProvider,
  searchResultDisplayType,
}

export default varsParams
